export default __webpack_public_path__ + "static/media/Edit.2fce9c7f.svg";